import React, { useContext, useEffect, useState } from 'react';
import View from './view';
import './style.scss';
import ChatContext from 'contexts/ChatContext';
import { useAppSelector } from 'careand-redux/store';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { uiActions } from 'careand-redux/slices/ui/ui';
import { api } from 'careand-redux/api/ApiThunks';
import { setFormValues } from 'hooks/useReduxForm';

const AdminChat = ({
  bubble,
  onArchive,
  visible,
}: {
  bubble: any;
  onArchive?: (a?: any, b?: any, roomName?: string) => void;
  visible?: boolean;
}) => {
  const dispatch = useAppDispatch();

  const activeLinkedAccount = useAppSelector((state) => state.ui.activeLinkedAccount);
  const patientId = bubble?.patient_id;

  const patients = useAppSelector((state) => state.patients.byId);
  const patient = useAppSelector((state) => state.patients.byId[patientId]);
  const userSubscription = useAppSelector((state) => state.payments.subscriptions[patientId]);
  const [loadedHR, setLoadedHR] = useState(false);
  const activePatient = useAppSelector(
    (state) => state.patients.byId[getActivePatientId(patientId, activeLinkedAccount, bubble)],
  );

  const { leaveRoom } = useContext(ChatContext);

  const [modal, setModal] = useState(false);
  const [transferring, setTransferring] = useState(false);

  useEffect(() => {
    if (visible && !loadedHR) {
      dispatch(api.HealthRecords.getCPP({ patientId }));
      setLoadedHR(true);
    }
  }, [dispatch, patientId, visible, loadedHR]);

  useEffect(() => {
    if (!userSubscription && visible)
      dispatch(api.Payments.getUserSubscription({ userId: patientId }));
  }, [dispatch, patientId, userSubscription, visible]);

  function onClose() {
    dispatch(uiActions.setActiveBubble(undefined));
  }

  function archiveChat() {
    onClose();
    if (bubble.room && onArchive) onArchive(undefined, undefined, bubble.room.id);
  }

  function handleIconClick(tab: string) {
    if (tab) {
      let newActiveBubble = {
        ...bubble,
        tab,
      };
      dispatch(uiActions.setActiveBubble(newActiveBubble));
    }
  }

  function setActiveLinkedAccountWrapper(selectedId: string) {
    if (patient) dispatch(uiActions.setActiveLinkedAccount(selectedId));
  }

  if (visible !== true) return null;

  function setChatMessage(message: string) {
    const formName = `ChatWindow-${(bubble || activePatient).id}`;
    dispatch(setFormValues({ formName, values: { currentMessage: message } }));
  }

  async function transferStaff(staff: any) {
    setModal(false);
    setTransferring(true);
    if (staff) {
      let options = { errorTitle: 'Helpdesk Message' };
      let chat = await dispatch(
        api.Chat.transferChat({
          chatId: bubble.room.id,
          userId: staff.id,
        }),
        options,
      );
      if (chat) {
        leaveRoom?.(bubble.room.id);
        dispatch(uiActions.setActiveBubble(undefined));
      }
    }
    setTransferring(false);
  }

  return (
    <View
      activeLinkedAccount={activeLinkedAccount}
      bubble={bubble}
      patients={patients}
      visible={visible}
      setChatMessage={setChatMessage}
      handleIconClick={handleIconClick}
      onClose={onClose}
      archiveChat={archiveChat}
      setActiveLinkedAccount={setActiveLinkedAccountWrapper}
      activePatient={activePatient}
      transferring={transferring}
      modal={modal}
      setModal={setModal}
      transferStaff={transferStaff}
    />
  );
};

function getActivePatientId(patientId: string, activeLinkedAccount: any, bubble: any) {
  let linkedAccountId = activeLinkedAccount[bubble?.id];
  if (linkedAccountId === undefined) linkedAccountId = patientId;
  return linkedAccountId;
}

export default AdminChat;
